import type {
  Command,
  Dependencias,
} from '@/features/proposta/brasil/domain/Comprador/form-to-listagem/comprador-listagem-command-factory'
import {
  gerarClienteMaePai,
  gerarNovoVinculo,
  tranformarCompradorFormParaCompradorProposta,
} from '@/features/proposta/brasil/domain/Comprador/form-to-listagem/mapper-comprador-pf-para-listagem'
import type {
  TClientePessoaFisicaPropostaSchema,
  TCompradorPropostaSchema,
} from '@/features/proposta/brasil/domain/schemas'
import type { CompradorPessoaFisicaStepSchemaInput } from '@/features/proposta/brasil/domain/schemas/compradores/comprador-pf.schema'

export class AtualizarCompradorComNovoPaiMaeCommand implements Command {
  constructor(
    private readonly comprador: CompradorPessoaFisicaStepSchemaInput,
    private readonly clientes: () => TClientePessoaFisicaPropostaSchema[],
    private readonly compradores: () => TCompradorPropostaSchema[],
    private readonly deps: Dependencias,
  ) {}

  executar() {
    const compradores = this.compradores()
    const clientes = this.clientes()
    const maePai = gerarClienteMaePai(this.comprador.maePai)
    if (!maePai) return
    const compradorIndex = compradores.findIndex((c) => c.clienteId === this.comprador.dados.id)
    const comprador = tranformarCompradorFormParaCompradorProposta(this.comprador)
    const novoVinculo = gerarNovoVinculo(this.comprador)

    const indexMaePai = clientes.findIndex((cliente) => cliente.id === maePai.id)
    if (indexMaePai === -1) {
      this.deps.adicionarCliente(maePai)
    } else {
      this.deps.atualizarCliente(indexMaePai, maePai)
    }
    const compradorAtualizado = {
      clienteId: comprador.clienteId,
      tipo: comprador.tipo,
      tipoAssinatura: comprador.tipoAssinatura,
      vinculos: [
        ...compradores[compradorIndex]!.vinculos,
        ...(compradores[compradorIndex]!.vinculos.some((vinculo) => vinculo.clienteId === novoVinculo.id)
          ? []
          : [
              {
                clienteId: novoVinculo.id,
                tipo: novoVinculo.tipo,
                vinculos: [],
              },
            ]),
      ],
    }
    this.deps.atualizarComprador(compradorIndex, compradorAtualizado)
  }
}
